module.exports = __webpack_public_path__ + "img/icon_right@2x.5af16ac1.png";